import { reportScreenTime } from '../../api/reportEvents';

// Frequency for querying the idle state (1 minute)
const queryIntervalInMillis = 60_000;

/**
 *  Reports pending Screen Time events every minute.
 */
export const startReportScreenTime = () => {
  setInterval(() => {
    reportScreenTime();
  }, queryIntervalInMillis);
};
